"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthMobileClient = void 0;
const axios_1 = __importDefault(require("axios"));
const AbstractAuthClient_1 = require("../Client/AbstractAuthClient");
const ChangePasswordModel_1 = require("../Model/Api/ChangePasswordModel");
const TokenMobileModel_1 = require("../Model/TokenMobileModel");
const AuthErrorHandleService_1 = require("../Service/HttpClient/AuthErrorHandleService");
class AuthMobileClient extends AbstractAuthClient_1.AbstractAuthClient {
    constructor(params) {
        super(params);
        this.httpClient = axios_1.default.create(this.httpClientDefaultConfig);
    }
    async login(props) {
        return new TokenMobileModel_1.TokenMobileModel(await this.loginResponse(props));
    }
    async refreshToken(params) {
        return new TokenMobileModel_1.TokenMobileModel(await this.refreshTokenResponse(params));
    }
    async changePassword(params, accessToken) {
        return new TokenMobileModel_1.TokenMobileModel(await this.changePasswordResponse(new ChangePasswordModel_1.ChangePasswordRequestModel(params), accessToken));
    }
    async loginTimeClock(params, accessToken) {
        try {
            const { data } = await this.httpClient.post('/v3/login/login_time_clock', {
                shop_id: params.shopId,
            }, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return new TokenMobileModel_1.TokenMobileModel({
                refreshToken: data.refresh_token,
                token: data.token,
            });
        }
        catch (error) {
            throw AuthErrorHandleService_1.AuthErrorHandleService.handleAuthResponseError(error);
        }
    }
    async refreshTimeClockToken(params) {
        try {
            const { data } = await this.httpClient.post('/v3/login/refresh_time_clock_token', {
                refresh_token: params.refreshToken,
            });
            return new TokenMobileModel_1.TokenMobileModel({
                refreshToken: data.refresh_token,
                token: data.token,
            });
        }
        catch (error) {
            throw AuthErrorHandleService_1.AuthErrorHandleService.handleRefreshResponseError(error);
        }
    }
}
exports.AuthMobileClient = AuthMobileClient;
//# sourceMappingURL=AuthMobileClient.js.map